import { Rule } from './Rule';
import { ActionMessage } from 'lib/constraintsChecker/ActionMessage';

export class ConstraintsCheckerData {
  static rules: Rule[] = [];
  static messages: ActionMessage[] = [];
}

export function setRules(rules: Rule[]): Rule[] {
  ConstraintsCheckerData.rules = rules;
  return rules;
}

function reviveRules(key: string, value: any) {
  return key === ''
    ? (value as Rule[]).map(item => Rule.fromJSON(item))
    : value;
}

export function loadRulesFromJson(json: string): Rule[] {
  /**
   * Convert JSON to Color[]
   * Save the colors Globally in DataStorage.colors
   * Save the colors in the localstorage
   */
  const rules: Rule[] = JSON.parse(json, reviveRules);
  setRules(rules);
  return rules;
}

export function setMessages(messages: ActionMessage[]): ActionMessage[] {
  ConstraintsCheckerData.messages = messages;
  return messages;
}

export function getMessages(): ActionMessage[] {
  if (
    !ConstraintsCheckerData.messages ||
    ConstraintsCheckerData.messages.length === 0
  )
    throw new Error('Messages must be loaded before call this function');
  return ConstraintsCheckerData.messages;
}

export function loadMessagesFromJson(json: string): ActionMessage[] {
  /**
   * Convert JSON to Color[]
   * Save the colors Globally in ConstraintsCheckerData.colors
   * Save the colors in the localstorage
   */
  const messages: ActionMessage[] = JSON.parse(json);
  setMessages(messages);
  return messages;
}
